import React from 'react';
import G from "../libs/Glob.mjs";
import TextLabel from "../controls/TextLabel.mjs";
import {Button, Form, Input} from "reactstrap";
import LanguageSwitcher from "../controls/LanguageSwitcher.mjs";
import appLib from "../libs/appLib.mjs";

const prefix ="PasswordForgot";

const PasswordForgot = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = { value: G.getStatus('passwordChangeForUser')||"" };
		this.state.valid = this.state.value.length > 4;
		this.uid = G.generateUid(prefix)
		this.setValue = this.setValue.bind(this);
	}

	setValue(v) {
		if ( v?.target ) v = v.target.value;
		v = (v||"").replace(/[^a-z0-9_@.-]/gi,'');
		this.setState({ value: v, valid: v.length > 4 });
	}

	render() {
		return(
			<div className={"Login " + prefix} id={this.uid}>
				<h4>
					<TextLabel value={"Forgot password"}/>
				</h4>
				<div>
					<LanguageSwitcher/>
					<span>
						<TextLabel value={"UsernameOrEmail"}/>
					</span>
				</div>
				<Form
					onSubmit={ e =>{
						e.preventDefault();
						if ( ! this.state.valid ) return;
						G.setStatus('passwordChangeForUser', this.state.value);
						appLib.askToken( this.state.value );
						G.setCurrentPageParam('action','change');
					}}
				>
					<div>
						<Input
							type={"text"}
							autoFocus={true}
							value={this.state.value || ''}
							placeholder={G.label('UsernameOrEmail')}
							onChange={ this.setValue }
						/>
						<div>
							<Button
								onClick={() => {
									G.rmCurrentPageParam('action')
								}}
							>
								<TextLabel value={"Cancel"}/>
							</Button>
							<Button
								type="submit"
								color={"primary"}
								disabled={ ! this.state.valid }
							>
								<TextLabel value={"Submit"}/>
							</Button>
						</div>
					</div>
				</Form>
			</div>
		)
	}
}

export default PasswordForgot;
